<template>
    <div>
        <div class="note" v-if="comment.name">
            <div class="header">
                <div class="icon">
                    {{ comment.name.charAt(0).toUpperCase() }}
                </div>
                <div class="name">
                    {{ comment.name }}
                </div>
                <div class="type myself" v-if="comment.user_id == currentUser.id">
                    {{ $t('general.chat.me') }}
                </div>
                <div class="type other" v-else-if="comment.user_type == 1">
                    {{ $t('general.chat.franchisee') }}
                </div>
                <div class="type other" v-else-if="comment.user_type == 5">
                    {{ $t('general.chat.consultant') }}
                </div>
                <div class="type other" v-else-if="comment.user_type == 3">
                    {{ $t('general.chat.manager') }}
                </div>
                <div class="type other" v-else>
                    {{ $t('general.chat.agency') }}
                </div>
                <div class="date">
                    {{ formatDate(comment.create_date) }}
                </div>
            </div>
            <div class="body">
                <div v-html="comment.message"></div>
            </div>
            <div class="footer" v-if="comment.images">
                <div class="images">
                    <div class="image" v-for="image in parsedImages">
                        <div class="image-container">
                            <img v-if="!isPdf(image)" :src="image" alt="" @click="openPreview(image)">
                            <img v-else class="file" src="../../../../public/img/file_link.png" alt="PDF" @click="openPdf(image)">
                        </div>
                        <div class="image-description">
                            <span class="name">{{ getFileName(image) }}</span>
                            <span class="extension">{{ getExtension(image) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer" v-if="!comment.images && commentId == comment.id">
                <div class="images">
                    <div class="image">
                        <img class="loader" src="../../../../public/img/loader.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="preview" v-if="preview">
            <div>
                <img :src="previewImage" alt="">
                <button @click="closePreview">{{ $t('general.close') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: {
        comment: Object,
        commentId: String
    },
    data() {
        return {
            currentUser: this.$store.getters['user/getUser'],
            preview: false,
            previewImage: null
        }
    },
    computed: {
        parsedImages() {
            return this.comment.images.split(',');
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('HH:mm DD/MM/YYYY')
        },
        getFileType(url) {
            const extension = url.split('.').pop().toLowerCase();
            
            if (extension === 'pdf') {
                return 'pdf';
            }
            return 'image';
        },
        isPdf(url) {
            return this.getFileType(url) === 'pdf';
        },
        openPreview(image) {
            if (this.isPdf(image)) {
                this.openPdf(image);
                return;
            }
            this.previewImage = image;
            this.preview = true;
        },
        openPdf(pdfUrl) {
            window.open(pdfUrl, '_blank');
        },
        closePreview() {
            this.preview = false;
            this.previewImage = null;
        },
        getFileName(url) {
            return new URL(url).pathname.split('/').pop().replace(/\.[^/.]+$/, '');
        },
        getExtension(url) {
            return url.split('.').pop().toUpperCase();
        }
    },
    mounted() {
    }
}
</script>
<style lang="scss" scoped>
.note {
    width: 100%;
    padding-bottom: 24px;
    .header {
        height: 24px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        color: #2C3E50;

        .icon {
            height: 24px;
            width: 24px;
            border-radius: 99px;
            background-color: #222222;
            color: #FFFFFF;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        
        .type {
            border-radius: 4px;
            padding: 4px;
            font-size: 12px;

            &.myself {
                background-color: #CCCCCC;
                color: #222222;
            }

            &.other {
                background-color: #004412;
                color: #FFFFFF;
            }
        }

        .date {
            font-size: 16px;
            color: #2C3E50;
        }
    }
    .body {
        color: #2C3E50;
        font-size: 14px;
        padding-top: 8px;
        text-align: left;
    }
    .footer {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        padding-top: 24px;

        .images {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .image {
                width: 176px;
                height: 88px;
                display: flex;
                flex-shrink: 0;
                padding: 4px;
                align-items: center;
                gap: 8px;
                border-radius: 8px;
                border: 1px solid #222222;
                background: #FFFFFF;

                .image-container {
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .file {
                        width: 36px;
                        height: 36px;
                    }

                }

                .loader {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    filter: invert(1);
                }

                .image-description {
                    font-size: 12px;
                    color: #2C3E50;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    flex: 1 0 0;
                    align-self: stretch;

                    .name {
                        width: 80px;
                        height: 80px;
                        overflow: hidden;
                        text-align: center;
                        color: #2C3E50;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        white-space: normal;
                        display: flex;
                        align-items: center;
                        word-break: break-word;

                    }

                    .extension {
                        width: 80px;
                        height: 26px;
                        overflow: hidden;
                        color: #757575;
                        text-align: left;
                        text-overflow: ellipsis;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
        
    }
}
.preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);

    div {
        width: fit-content;
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0px;

        img {
            height: 600px;
        }
        button {
            background-color: #FFBB0C;
            color: #222222;
            width: 100%;
            font-size: 22px;
            line-height: 50px;
        }
    }
}
</style>
